var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.achType === "论文"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "flex items-center" },
            [
              _c(
                "div",
                {
                  staticClass: "achTitle pointer",
                  on: {
                    click: function ($event) {
                      return _vm.goDetails("/paperDetail", _vm.achData.id)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.achData.title) + " ")]
              ),
              _vm._l(
                _vm.achData.jcrPartitionList,
                function (jcrItem, jcrIndex) {
                  return _c("div", { key: jcrIndex }, [
                    jcrItem
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "background-color": "#1241C9",
                              "border-radius": "3px",
                              "font-size": "12px",
                              color: "white",
                              padding: "3px 10px",
                              "margin-left": "10px",
                            },
                          },
                          [_vm._v(" " + _vm._s(jcrItem) + " ")]
                        )
                      : _vm._e(),
                  ])
                }
              ),
            ],
            2
          ),
          _c("div", [
            _c("div", { staticClass: "flex flex-wrap" }, [
              _c(
                "div",
                { staticClass: "flex achLine wrap" },
                [
                  _c("div", { staticStyle: { "white-space": "nowrap" } }, [
                    _vm._v("作者："),
                  ]),
                  _vm._l(
                    _vm.achData.authorList.length > 6
                      ? _vm.achData.authorList.slice(0, 6)
                      : _vm.achData.authorList,
                    function (personItem, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "flex items-center",
                          staticStyle: { "margin-right": "10px" },
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              "border-radius": "50%",
                              "margin-right": "5px",
                            },
                            attrs: {
                              src: personItem.avatarUrl,
                              width: "14",
                              height: "14",
                            },
                          }),
                          _c(
                            "div",
                            { staticStyle: { "white-space": "nowrap" } },
                            [
                              _vm._v(
                                _vm._s(
                                  personItem.name || personItem.scholarName
                                )
                              ),
                            ]
                          ),
                        ]
                      )
                    }
                  ),
                  _vm.achData.authorList.length > 6
                    ? _c("p", [_vm._v("...")])
                    : _vm._e(),
                  _vm.achData.authorList.length === 0
                    ? _c("p", [_vm._v("-")])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "flex" }, [
              _c(
                "div",
                {
                  staticClass: "achLine ellipsis",
                  staticStyle: {
                    "white-space": "nowrap",
                    "max-width": "650px",
                  },
                  attrs: {
                    title: _vm.achData.journalConf || _vm.achData.venue,
                  },
                },
                [
                  _c("span", [_vm._v("出版物：")]),
                  _vm._v(
                    _vm._s(
                      _vm.achData.journalConf || _vm.achData.venue || "-"
                    ) + " "
                  ),
                ]
              ),
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("卷号：")]),
                _vm._v(_vm._s(_vm.achData.volume || "-")),
              ]),
            ]),
            _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("引用次数：")]),
                _vm._v(
                  _vm._s(
                    _vm.achData.citationCount || _vm.achData.citationNum || "0"
                  )
                ),
              ]),
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("发表时间：")]),
                _vm._v(_vm._s(_vm.achData.pubDate || _vm.achData.year)),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.achType === "专利"
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "achTitle pointer",
              on: {
                click: function ($event) {
                  return _vm.goDetails("/patentDetail", _vm.achData.id)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.achData.title) + " ")]
          ),
          _c("div", [
            _c("div", { staticClass: "flex" }, [
              _c(
                "div",
                { staticClass: "flex achLine" },
                [
                  _c("span", [_vm._v("发明人：")]),
                  _vm._l(_vm.achData.authors, function (personItem, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "flex items-center",
                        staticStyle: { "margin-right": "10px" },
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            "border-radius": "50%",
                            "margin-right": "5px",
                          },
                          attrs: {
                            src: personItem.avatarUrl,
                            width: "14",
                            height: "14",
                          },
                        }),
                        _c("div", [_vm._v(_vm._s(personItem.scholarName))]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("申请人：")]),
                _vm._v(_vm._s(_vm.achData.applicantName || "-")),
              ]),
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("申请时间：")]),
                _vm._v(_vm._s(_vm.achData.year)),
              ]),
            ]),
            _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("专利类型：")]),
                _vm._v(_vm._s(_vm.achData.patentType)),
              ]),
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("公开日期：")]),
                _vm._v(
                  _vm._s(_vm.formatToDate(_vm.achData.publicationDate)) + " "
                ),
              ]),
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("公开(公告)号：")]),
                _vm._v(_vm._s(_vm.achData.publicationNum || "-")),
              ]),
              _c("div", { staticClass: "achLine" }, [
                _c("span", [_vm._v("申请号：")]),
                _vm._v(_vm._s(_vm.achData.applicationNum || "-")),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.achType === "项目"
      ? _c("div", { staticClass: "achievement-item project-item" }, [
          _c("h3", { staticClass: "title" }, [
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.toDetail(_vm.achData.id, "/projectDetail")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.achData.title || "-"))]
            ),
          ]),
          _c("div", { staticClass: "info" }, [
            _vm.achData.leader
              ? _c("div", { staticClass: "flex items-center" }, [
                  _c(
                    "span",
                    { staticStyle: { color: "#667085", "font-size": "14px" } },
                    [_vm._v("负责人：")]
                  ),
                  _vm.achData.leader
                    ? _c(
                        "p",
                        {
                          staticClass: "flex items-center",
                          staticStyle: {
                            cursor: "pointer",
                            "font-size": "14px",
                            "max-width": "300px",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                            "white-space": "nowrap",
                            color: "#101828",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goPersonalDetails(
                                _vm.achData.leader.id
                              )
                            },
                          },
                        },
                        [
                          _c("el-avatar", {
                            attrs: {
                              size: 22,
                              src:
                                _vm.achData.leader && _vm.achData.leader.avatar,
                            },
                          }),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "10px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.achData.leader &&
                                    _vm.achData.leader.scholarName
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "p",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            "max-width": "300px",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                            "white-space": "nowrap",
                            color: "#101828",
                          },
                        },
                        [_vm._v(" - ")]
                      ),
                ])
              : _vm._e(),
            _vm.achData.startYear
              ? _c(
                  "div",
                  {
                    staticClass: "flex items-center",
                    staticStyle: {
                      "margin-left": "30px",
                      color: "#667085",
                      "font-size": "14px",
                    },
                  },
                  [
                    _c("span", [_vm._v("批准年份：")]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "max-width": "300px",
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                          "white-space": "nowrap",
                          color: "#101828",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.achData.startYear || "") + " ")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.achData.typeFirst
              ? _c(
                  "div",
                  {
                    staticClass: "flex items-center",
                    staticStyle: {
                      "margin-left": "30px",
                      color: "#667085",
                      "font-size": "14px",
                    },
                  },
                  [
                    _c("span", [_vm._v("项目类别：")]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "max-width": "300px",
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                          "white-space": "nowrap",
                          color: "#101828",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.achData.typeFirst || "-") + " ")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.achData.projectSource
              ? _c(
                  "div",
                  {
                    staticClass: "flex items-center",
                    staticStyle: {
                      "margin-left": "30px",
                      color: "#667085",
                      "font-size": "14px",
                    },
                  },
                  [
                    _c("span", [_vm._v("项目来源：")]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "max-width": "300px",
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                          "white-space": "nowrap",
                          color: "#101828",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.achData.projectSource || "-") + " "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }